import {memo} from 'react'
import {Timeline} from '@primer/react'
import {
  CommentIcon,
  GitMergeIcon,
  GitPullRequestClosedIcon,
  GitPullRequestIcon,
  PersonIcon,
  TagIcon,
  InfoIcon,
  EyeIcon,
  EyeClosedIcon,
  GitCommitIcon,
  CrossReferenceIcon,
  CommentDiscussionIcon,
  DiffIcon,
  CheckIcon,
} from '@primer/octicons-react'
import type {IssueEventType, PullRequestReviewState, TimelineItem} from '../../../page-data/payloads/timeline'

type BadgeConfig = {icon: React.ReactNode}

const STATIC_BADGE_CONFIG: Partial<Record<TimelineItem['type'], BadgeConfig>> = {
  IssueComment: {icon: <CommentIcon />},
  PullRequestCommit: {icon: <GitCommitIcon />},
  CrossReference: {icon: <CrossReferenceIcon />},
  PullRequestReviewThread: {icon: <CommentDiscussionIcon />},
  PullRequestRevisionMarker: {icon: <DiffIcon />},
}

const ISSUE_EVENT_BADGE_CONFIG: Partial<Record<IssueEventType, BadgeConfig>> = {
  merged: {icon: <GitMergeIcon className="color-fg-done" />},
  closed: {icon: <GitPullRequestClosedIcon className="color-fg-closed" />},
  reopened: {icon: <GitPullRequestIcon className="color-fg-open" />},
  assigned: {icon: <PersonIcon />},
  unassigned: {icon: <PersonIcon />},
  labeled: {icon: <TagIcon />},
  unlabeled: {icon: <TagIcon />},
  review_requested: {icon: <EyeIcon />},
  review_request_removed: {icon: <EyeClosedIcon className="color-fg-muted" />},
}

const REVIEW_STATE_BADGE_CONFIG: Partial<Record<PullRequestReviewState, BadgeConfig>> = {
  approved: {icon: <CheckIcon className="color-fg-success" />},
  changes_requested: {icon: <EyeIcon className="color-fg-danger" />},
}

function renderBadge(config: BadgeConfig) {
  return <Timeline.Badge>{config.icon}</Timeline.Badge>
}

export const TimelineItemBadge = memo(function TimelineItemBadge({item}: {item: TimelineItem}) {
  if (item.type === 'IssueEvent') {
    return renderBadge(ISSUE_EVENT_BADGE_CONFIG[item.additionalInfo.eventType] ?? {icon: <InfoIcon />})
  }
  if (item.type === 'PullRequestReview') {
    return renderBadge(REVIEW_STATE_BADGE_CONFIG[item.additionalInfo.state] ?? {icon: <EyeIcon />})
  }
  return renderBadge(STATIC_BADGE_CONFIG[item.type] ?? {icon: <InfoIcon />})
})
